export enum Label {
  error = 'Ошибка',
  email = 'Email',
  password = 'Пароль',
}
